import React, { useState } from 'react'
import { useGetIndustryListQuery } from '../../../store/cmsService'
import { Interest, TagIconMap } from '../types'
import InterestTile from './InterestTile'
import IndustriesIconMapper from './IndustriesIconMapper'

interface IndustriesSelectorProps {
  defaultSelected?: number[]
  onChange: (value: number[]) => void
}

const IndustriesSelector = ({
  defaultSelected = undefined,
  onChange,
}: IndustriesSelectorProps) => {
  const { data } = useGetIndustryListQuery()
  const [selected, setSelected] = useState<number[]>(defaultSelected ?? [])
  const tagIconMap: TagIconMap = IndustriesIconMapper()

  const interests = data?.data
    ?.filter((interest) => {
      const tag = interest.tag?.split('/')?.pop()
      return !tag?.match('government-public-sector-canada')
    })
    ?.map((interest) => {
      const tag = interest.tag?.split('/')?.pop()
      return tag ? { ...interest, icon: tagIconMap[tag] } : interest
    }) as Interest[]

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {interests?.map((interest, index) => (
        <InterestTile
          key={interest.tag}
          testId="Industry"
          checked={selected.includes(interest.id)}
          index={index}
          interest={interest}
          onClick={(checked) => {
            const value = checked
              ? [...selected, interest.id]
              : selected.filter((i) => i !== interest.id)
            setSelected(value)
            onChange(value)
          }}
        />
      ))}
    </>
  )
}

export default IndustriesSelector
